export default function wrapIn() {
    return function(value, start, end) {
        if (value !== undefined) {
            return start + value + end;
        }
    }
};
